module.exports = __webpack_public_path__ + "img/job-dashboard-selected.6a7a0af2.svg";